module.exports = __webpack_public_path__ + "static/media/sub-table-sample-2.93cff49f.png";